/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CHALLENGE_ISSUE_STATUSES = ['open', 'resolved', 'dismissed'] as const;

export const challengeIssueStatusSchema = z.enum(CHALLENGE_ISSUE_STATUSES);

export type IChallengeIssueStatus = z.infer<typeof challengeIssueStatusSchema>;

export const CHALLENGE_ISSUE_STATUS_LABELS: Record<IChallengeIssueStatus, string> = {
  open: 'Open',
  resolved: 'Resolved',
  dismissed: 'Dismissed',
};
